import React, {PropsWithChildren} from 'react';

import './label.scss';

export type LabelSizeType = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface PromptProps {
    className?: string;
    size?: LabelSizeType;
}

function Label(props: PropsWithChildren<PromptProps>): JSX.Element {
    const {children, className, size = 'sm'} = props;

    return <div className={`c-label c-label--size-${size} ${className}`}>{children}</div>;
}

export default Label;
